export const convertToCurrencyNumber = (
  value: number,
  numberOfdecimal?: number
) => {
  if (Number.isNaN(value)) {
    return "";
  } else if (numberOfdecimal === 0) {
    return new Intl.NumberFormat("th-TH").format(value);
  } else {
    // value = Math.floor(value * 100) / 100;
    value = (value * 100) / 100;
    const currentNumber = new Intl.NumberFormat("th-TH", {
      minimumFractionDigits: numberOfdecimal || 2,
      maximumFractionDigits: numberOfdecimal || 2
    }).format(value);
    return currentNumber;
  }
};
